/**
 * @file HeaderMenuSlot.tsx
 *
 * @fileoverview This component can be used to render custom things next to the menu in the header.
 */

import { Menu } from '~/jobiqo/models/navigation';

interface HeaderMenuSlotProps {
  userMenu: Menu;
}

export const HeaderMenuSlot = ({ userMenu }: HeaderMenuSlotProps) => {
  return null;
};

export default HeaderMenuSlot;
